import { defineComponent, h } from 'vue';
import { QCard, QTabs, QTab, QTabPanels, QTabPanel } from 'quasar';
import utils from '../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

import TranslationContainer from './TranslationContainer.jsx';

export default defineComponent({
    name: 'basic-tab',
    mixins: [BaseComponent],
    components: {
        QCard,
        QTabs,
        QTab,
        QTabPanels,
        QTabPanel,
        TranslationContainer,
    },
    data: function () {
        return {
            selected_tab: 0,
        }
    },
    props: {},
    created() {
        for (let tabi = 0; tabi < this.controlData.TabControls.length; tabi++) {
            const tab = this.controlData.TabControls[tabi];
            if (tab.DisplayExpression)
                tab.todisplayexpn = utils.compileExpression(this, tab.DisplayExpression);
            if (tab.Title)
                tab.titleexpr = utils.compile(this, tab.Title);
        }
    },
    //Mounted Replaced with preRenderComplete
    computed: {
        styles: function () {
            return {
                display: "flex",
                flexDirection: "column",
                flexGrow: "1",
                //flexShrink: "0",
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
                overflowX: "clip",
                overflowY: "auto",
                whiteSpace: "nowrap",
            };
        },
        bodystyles: function () {
            return {
                display: "flex",
                flexDirection: "column",
                flexGrow: "1",
                overflow: "auto",
            };
        },
        classes() {
            return {
                'c-BasicTab': true, 
                [`c-name-${this.Name}`]: true
            }
        },

        totalItems() {
            // Count only the controls in the currently selected tab.
            // This ensures the component finishes rendering once the default view is ready,
            // rather than waiting for every control on every tab (some of which may never load).
            const tab = this.controlData.TabControls[this.selected_tab];
            let count = 0;
            if (tab) {
                const isTabVisible = tab.todisplayexpn ? utils.evaluate(tab.todisplayexpn, this) : true;
                if (isTabVisible && Array.isArray(tab.Controls)) {
                    count = tab.Controls.length;
                }
            }

            console.log(`BasicTab ${this.name} has ${count} children`);
            return count + 1;
        },

        Tab: function () {
            // Public property
            const tab = this.controlData.TabControls[this.selected_tab];
            if (tab)
                return {
                    Title: tab.titleexpr ? utils.evaluate(tab.titleexpr, this) : 'Untitled',
                    Controls: tab.Controls,
                };
            else
                return {};
        },
    },
    methods: {
        preRenderComplete() {
            if (Array.isArray(this.controlData?.TabControls)) {
                const firstVisibleIndex = this.controlData.TabControls.findIndex(tab => {
                    if (!tab.todisplayexpn) return true;
                    return !!utils.evaluate(tab.todisplayexpn, this);
                });

                if (firstVisibleIndex !== -1) {
                    this.selected_tab = firstVisibleIndex;
                }
            }
            this.finishRenderHandler(this);
        },
        onTabModelUpdate(index) {
            utils.hideAllTooltipsNow();
            this.selected_tab = index;
        },
    },
    render() {
        if (!this.todisplay)
            return null;

        try {
            const tabs = [];
            const tab_body = [];
    
            for (let tabi = 0; tabi < this.controlData.TabControls.length; tabi++) {
                const tab = this.controlData.TabControls[tabi];
                if (tab.todisplayexpn)
                    if (!utils.evaluate(tab.todisplayexpn, this))
                        continue;

                const title = <TranslationContainer context={this} value={tab.Title ? tab.Title : 'Untitled'}></TranslationContainer>;

                tabs.push(
                    <QTab key={tabi} name={tabi} class="text-capitalize">
                        {title}
                    </QTab>
                );
    
                const items = [];
    
                for (let i = 0; i < tab.Controls.length; i++) {
                    const c = tab.Controls[i];
    
                    if (!(typeof c === 'object'))
                        continue;
    
                    let DynamicControl = utils.getDynamicComponent(h, c);
    
                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';
    
                    if (!c.$objectId) c.$objectId = utils.generateUUID();
    
                    let id = c.$objectId;
    
                    items.push(
                        <DynamicControl
                            key={id}
                            onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                            type={c.ControlType}
                            name={c.ControlData.Name ? c.ControlData.Name : ''}
                            root={this.root}
                            parentType="BasicTab"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            controlName={c.Name}
                            accessPermission={c.AccessPermission}
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            cacheControl={c.CacheControl}
                            controlEvents={c.Events}>
                        </DynamicControl>
                    );
                }
    
                tab_body.push(
                    <QTabPanel key={tabi} name={tabi} class="q-pa-none">
                        {items}
                    </QTabPanel>
                );
            }
        
            return (
                <QCard
                    flat
                    class={this.classes}
                    v-show={this.isvisible}
                    style={this.styles}
                >
                    <QTabs
                        indicatorColor="transparent"
                        align="left"
                        breakpoint={0}
                        style={{ color: 'var(--v-secondaryText-base)' }}
                        xstyle={{ flexGrow: 0, flexShrink: 0 }}
                        xclass="q-ma-sm"
                        modelValue={this.selected_tab}
                        onUpdate:modelValue={(index) => this.onTabModelUpdate(index)}
                    >
                        {tabs}
                    </QTabs>

                    <QTabPanels modelValue={this.selected_tab} onUpdate:modelValue={(index) => this.onTabModelUpdate(index)} style={this.bodystyles} class="q-pa-none" keep-alive animated>
                        {tab_body}
                    </QTabPanels>
                </QCard>
            );
        }
        catch (e) {
            utils.error('BasicTab Render failed', e);
            return <div>BasicTab Failed to Render {e}</div>;
        }
    }
});